export enum FORMAT_INCLUDE {
  NUMBER = 'Number',
  CURRENCY = 'Currency',
  POINT = 'Point',
  PERCENT = 'Percent',
  UNIX = 'Unix',
  RATE = 'Rate',
  DATE = 'Date',
  DURATION = 'Duration',
}

export enum FORMAT_TYPE {
  NUMBER = 'Number',
  NUMBER_ABBREVIATED = 'Number Abbreviated',
  NUMBER_SCALE = 'Number Scale',
  NUMBER_FIXED = 'Number Fixed',
  NUMBER_BYTES = 'Number Bytes',
  RATE = 'Rate',
  RATE_FIXED = 'Rate Fixed',
  CURRENCY = 'Currency',
  CURRENCY_ABBREVIATED = 'Currency Abbreviated',
  CURRENCY_SCALE = 'Currency Scale',
  PERCENT = 'Percent',
  PERCENT_ABBREVIATED = 'Percent Abbreviated',
  PERCENT_FIXED = 'Percent Fixed',
  UNIX = 'Unix',
  UNIX_SHORT = 'Unix Short',
  UNIX_TIME = 'Unix Time',
  UNIX_TIME_SHORT = 'Unix Time Short',
  DATE = 'Date',
  DATE_SHORT = 'Date Short',
  DATE_SHORT_YEAR = 'Date Short Year',
  DATE_HOUR = 'Date Hour',
  DATE_WEEKDAY = 'Weekday',
  DATE_WEEKDAY_SHORT = 'Weekday Short',
  DATE_TIME = 'Date Time',
  DATE_TIME_SHORT = 'Date Time Short',
  DATE_SHORT_TIMEZONE = 'Date Short Timezone',
  DATE_TIME_SHORT_TIMEZONE = 'Date Time Short Timezone',
  DATE_TIME_SECONDS = 'Date Time Seconds',
  DATE_TIME_SHORT_SECONDS = 'Date Time Short Seconds',
  NONE = 'None',
  DURATION_SECONDS = 'Duration in Seconds',
  DURATION_MINUTES = 'Duration in Minutes',
  DURATION_HOURS = 'Duration in Hours',
}
